import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Users, Sparkles, Leaf } from 'lucide-react';

const servicesData = [
  {
    id: 'weddings',
    icon: Heart,
    title: 'Weddings',
    description: 'Traditional and contemporary wedding ceremonies crafted to honor your unique love story.',
    features: ['Personalized vows assistance', 'Rehearsal coordination', 'Custom ceremony design'],
  },
  {
    id: 'vow-renewals',
    icon: Sparkles,
    title: 'Vow Renewals',
    description: 'Celebrate your continued commitment with a meaningful renewal ceremony.',
    features: ['Anniversary celebrations', 'Milestone renewals', 'Intimate gatherings'],
  },
  {
    id: 'commitment-ceremonies',
    icon: Users,
    title: 'Commitment Ceremonies',
    description: 'Honoring partnerships with ceremonies that reflect your values and bond.',
    features: ['Inclusive celebrations', 'Customized rituals', 'All faiths welcome'],
  },
  {
    id: 'elopements',
    icon: Leaf,
    title: 'Elopements',
    description: 'Intimate ceremonies for couples seeking a private, meaningful exchange of vows.',
    features: ['Flexible locations', 'Quick turnaround', 'Witness services available'],
  },
];

const ServicesPreview = () => {
  const basePath = '/dnfministry';
  
  return (
    <section style={{ maxWidth: '80rem', margin: '0 auto', padding: '6rem 1rem' }}>
      {/* Section Header */}
      <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
        <p style={{ color: '#B8860B', letterSpacing: '0.3em', textTransform: 'uppercase', fontSize: '0.875rem', marginBottom: '1rem' }}>
          Sacred Services
        </p>
        <h2 className="font-serif" style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)', color: '#F5F5DC', marginBottom: '1.5rem' }}>
          Ceremonies for Every Journey
        </h2>
        <div className="divider-gold" style={{ maxWidth: '12rem', margin: '0 auto' }} />
        <p style={{ color: 'rgba(245,245,220,0.7)', maxWidth: '42rem', margin: '1.5rem auto 0', lineHeight: 1.7 }}>
          Every love story deserves a ceremony as unique as the souls it unites.
          We offer a range of services to honor your special moment.
        </p>
      </div>

      {/* Services Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
        {servicesData.map((service, index) => {
          const IconComponent = service.icon;
          return (
            <div
              key={service.id}
              className="card-elegant animate-fade-in"
              style={{ 
                padding: '2rem',
                animationDelay: `${index * 0.1}s`
              }}
              data-testid={`service-card-${service.id}`}
            >
              {/* Icon */}
              <div style={{ 
                width: '4rem', 
                height: '4rem', 
                borderRadius: '50%', 
                backgroundColor: 'rgba(184,134,11,0.1)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                marginBottom: '1.5rem'
              }}>
                <IconComponent style={{ width: '2rem', height: '2rem', color: '#B8860B' }} />
              </div>

              {/* Content */}
              <h3 className="font-serif" style={{ fontSize: '1.5rem', color: '#F5F5DC', marginBottom: '1rem' }}>
                {service.title}
              </h3>
              <p style={{ color: 'rgba(245,245,220,0.7)', marginBottom: '1.5rem', lineHeight: 1.6 }}>
                {service.description}
              </p>

              {/* Features */}
              <ul style={{ marginBottom: '1.5rem', listStyle: 'none', padding: 0 }}>
                {service.features.map((feature, idx) => (
                  <li key={idx} style={{ display: 'flex', alignItems: 'center', fontSize: '0.875rem', color: 'rgba(245,245,220,0.6)', marginBottom: '0.5rem' }}>
                    <span style={{ width: '6px', height: '6px', backgroundColor: '#B8860B', borderRadius: '50%', marginRight: '0.75rem' }} />
                    {feature}
                  </li>
                ))}
              </ul>

              {/* Link */}
              <Link
                to={`${basePath}/services/${service.id}`}
                style={{ color: '#B8860B', fontSize: '0.875rem', letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none' }}
              >
                Learn More →
              </Link>
            </div>
          );
        })}
      </div>

      {/* CTA */}
      <div style={{ textAlign: 'center', marginTop: '4rem' }}>
        <Link
          to={`${basePath}/services`}
          className="btn-gold-outline"
          style={{ fontSize: '0.875rem', letterSpacing: '0.2em', textTransform: 'uppercase', textDecoration: 'none' }}
          data-testid="view-all-services-btn"
        >
          View All Services & Packages
        </Link>
      </div>
    </section>
  );
};

export default ServicesPreview;
